import { createApp } from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload';
import router from './router'
import './assets/tailwind.css'

const app = createApp(App)

app.use(VueLazyload, {
    preLoad: 1.3,
    error: 'path/to/error.png', // optional
    loading: 'path/to/loading.gif', // optional
    attempt: 1,
  });

  

app.use(router)
app.mount('#app')
